import { Collapse } from 'bootstrap';

// eslint-disable-next-line no-unused-vars
const AccordionGroup = {
  onReady: () => {
    (function ($) {
      $('.accordion').each(function () {
        // Make sure jQuery is loaded only once otherwise bootstrap events will not work https://stackoverflow.com/a/62751631/791441
        const accordion = new Collapse(this, {
          toggle: false, // Disable Bootstrap's default toggle behavior
        });

        // Handle accordion button clicks
        $(this)
          .find('.accordion-button')
          .on('click', function () {
            // Get the target accordion item
            const accordionItem = $(this).closest('.accordion-item');
            // Find the closest accordion container by class.
            const $accordionContainer = $(this).closest('.accordion');
            const accordionContainerClass = $accordionContainer.attr('id');
            // Get the unique ID from the data attribute
            const accordionId = accordionItem.data('bs-accordion-id');

            // Check if the clicked accordion item is already open
            const isOpen = accordionItem.hasClass('active');

            // If not, close all accordion items and open the clicked one
            if (!isOpen) {
              // Manually hide all accordion items and remove the "active" class
              accordionItem.siblings('.accordion-item').removeClass('active');
              accordion.hide();

              accordionItem.addClass('active'); // Mark the clicked item as active
            } else {
              const childDiv = accordionItem.find('.accordion-collapse');
              childDiv.removeClass('collapsing');
              childDiv.addClass('show');
              $(this).removeClass('collapsed');
            }

            // Detect the currently selected accordion and display the corresponding right-side content
            const selectedImageContentId = accordionId + '-right-content';

            // Hide all right-side content
            $('.section-accordion-right', '.' + `${accordionContainerClass}-associate`).hide();

            // Display the right-side content corresponding to the currently selected accordion
            $('.section-accordion-right.' + selectedImageContentId).show();
          });
      });

      // Detect the initially selected accordion on page load
      $('.accordion-item.active').each(function () {
        const accordionItem = $(this);
        const selectedId = accordionItem.find('button').attr('data-bs-target');
        const selectedRightContentId = selectedId.replace('#', '') + '-right-content';

        // Hide all right-side content
        $('.section-accordion-right.' + selectedRightContentId).hide();

        // Display the right-side content corresponding to the initially selected accordion

        $('.section-accordion-right.' + selectedRightContentId).show();
      });
    })(jQuery);
  },
};

export default AccordionGroup;
